import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.main`
  min-height: var(--app-height);
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  font-family: ${({ theme }) => theme.font.fontFamily};
`;

// Mesmo cartão centralizado da resposta de validação: quem chega aqui veio de
// um link externo (a apresentação da seletiva) e não tem sessão nem menu.
export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  width: 100%;
  max-width: 560px;
  padding: 40px 32px;

  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  text-align: center;

  ${media.lessThan("small")`
    padding: 32px 20px;
  `}
`;

export const Logo = styled.img`
  width: 160px;
  height: auto;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 32px;
  line-height: 1;

  background-color: ${({ theme, $variant }) =>
    $variant === "error"
      ? theme.colors.feedbackState.critical.default
      : theme.colors.feedbackState.success.default};
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.font.heading.x};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
`;

export const Message = styled.p`
  font-size: ${({ theme }) => theme.font.body.md};
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.neutral.dark};
`;

export const ProjectName = styled.strong`
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  button {
    width: 100%;
  }
`;
